import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Button, Box, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'; // Dialog 関連を追加
import { AccountCircle } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import logo from '../YSlogo.svg'; // logo.svg をインポート

const CheckSignOutDialog = ({ open, onClose }) => {
    const { signOut } = useAuthenticator();
    const navigate = useNavigate();

    const handleSignOut = () => {
        signOut();
        navigate('/'); // ホームページに戻る
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="signout-dialog-title"
            aria-describedby="signout-dialog-description"
        >
            <DialogTitle id="signout-dialog-title">ログアウトの確認</DialogTitle>
            <DialogContent>
                <DialogContentText id="signout-dialog-description">
                    ログアウトしますか？
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSignOut} variant="contained" color="primary">
                    ログアウトする
                </Button>
                <Button onClick={onClose} variant="outlined" color="secondary" autoFocus>
                    キャンセル
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const Navbar = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [openDialog, setOpenDialog] = useState(false);
    const navigate = useNavigate();

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <AppBar position="fixed" sx={{ backgroundColor: '#FFFFFF', color: '#233D97', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
            <Toolbar style={{ justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <IconButton color="inherit" aria-label="account" component={Link} to="/account" sx={{ color: '#233D97', mb: -0.5 }}>
                        <AccountCircle sx={{ fontSize: '2.4rem', marginBottom: '-3px', marginTop: '-5px' }} />
                    </IconButton>
                    <Typography sx={{ fontSize: '0.7em', color: '#233D97', marginTop: '-3px' }}>アカウント</Typography>
                </Box>
                {/*
                <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', color: '#233D97', textDecoration: 'none' }}>
                        <img src={logo} alt="ロゴ" style={{ height: '38px' }} />
                    </Link>
                </div>
                */}
                <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Link to="/" style={{ display: 'flex', alignItems: 'center', color: '#233D97', textDecoration: 'none' }}>
                        <h1>無人.com</h1>
                    </Link>
                </div>
                {user ? (
                    <Button sx={{ color: '#233D97', fontSize: '1em' }} onClick={handleOpenDialog}>
                        ログアウト
                    </Button>
                ) : (
                    <Button sx={{ color: '#233D97', fontSize: '1em' }} component={Link} to="/signin">
                        ログイン
                    </Button>
                )}
            </Toolbar>
            <CheckSignOutDialog open={openDialog} onClose={handleCloseDialog} />
        </AppBar>
    );
};

export default Navbar;
